import ClubIconBtn from '../../../../images/logo-clube-decathlon.svg'
import ArrowBtnClube from '../../../../images/arrowBtnClube.svg'

const ButtonClube = () => {
  return (
    <a
      href="/clube"
      className="flex gap-2 py-2 px-3 text-[#3643BA] text-sm leading-[23px] md:text-[11px] md:leading-[25px]"
    >
      <img width={16} height={18} src={ClubIconBtn} alt="iconClub" />
      <span className="whitespace-nowrap font-bold">
        O Clube está de cara nova!
      </span>
      <img src={ArrowBtnClube} alt="ícone de uma seta para direita" />
    </a>
  )
}

export default ButtonClube
